/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import { RouteObject } from 'react-router-dom';
import { NomineeKYCPage } from './navigation';
import { SidebarWidget } from '@widgets/sidebar-widget-react';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { routes } from '@/AppNavigator/services/config/routes.config';

export const getNomineeKYCPageRoute = (props: any): RouteObject | any => {
  const storageSrv = StorageModule?.getInstance();
  const navigate = useNavigate();
  const _handleDropDownItemClick = (item: any) => {
    console.log(`id`, item?.id);
    if (item.id === 'logout') {
      storageSrv.reset('session');
      storageSrv.reset('local');
      navigate(`/product/bharat-life-saral-jeevan-bima`);
    } else if (item.id === 'myProfile') {
      navigate(routes?.MyAccount?.path);
    } else {
      toast.success('Coming soon!');
    }
  };

  return {
    path: '/my-payout-detail',
    element: (
      <SidebarWidget
        {...props}
        component={NomineeKYCPage}
        onDropDownItemClick={_handleDropDownItemClick}
        // abilityCheck={srv.abilityCheck.bind(
        //   null,
        //   props?.routes?.Profile?.id,
        //   props.whoami,
        //   'read'
        // )}
      />
    ),
  };
};
